import {useDispatch, useSelector} from 'react-redux';
import Input from '../../../components/form/Input';
import LabeledSelect from "../../../components/selects/LabeledSelect";
import {differenceWith, isEmpty} from "lodash";
import JobCardLoader from "./JobCardLoader";
import {getCampaignInfo, getShifts, getUserBookedShift} from "../../../redux/slices/nurseCampaignSlice";
import {utcToLocalTimeString} from "../../../helpers/dateTimeHelper";
import {useEffect, useState} from "react";

const UpdateOrderForm = ({updateOrder, order, campaignId, selectedAppointment}) => {
  const dispatch = useDispatch();

  const {
    shiftList,
    disabledShift,
    campaignInfo,
    loadingCampaignInfo,
    campaignInfoError,
    shiftListError,
    loadingShiftList,
    bookedShift
  } = useSelector((state) => state.campaign);
  const [availableShift, setAvailableShift] = useState([]);

  useEffect(() => {
    dispatch(getUserBookedShift({campaignId, patientId: selectedAppointment?.requested_for?.id}));
  }, []);

  useEffect(() => {
    //filter booked shift of particular user based on selected date
    const filteredShift = bookedShift.filter((data) => data.appointment_date === order?.date?.value);
    //remove unavailable shift and disable shift that user has already booked
    setAvailableShift(
      order?.date?.length === 0 || order?.date === undefined ? [] :
        differenceWith(shiftList.filter((shift) => !shift.disabled), disabledShift,
          (shift, bookshift) => shift?.id === bookshift?.shift && order?.date.value === bookshift.date)
          .map((data) =>
            filteredShift.find((filteredShift) => filteredShift.shift_id === data.id ) && data?.id !== selectedAppointment?.shift_id ? {
              ...data,
              isDisabled: true
            } : data)
    );
  }, [bookedShift, order?.date]);


  return (<>
      {loadingCampaignInfo || isEmpty(campaignInfo) || !isEmpty(campaignInfoError) || loadingShiftList || isEmpty(shiftList) || !isEmpty(shiftListError) ? (
        <JobCardLoader
          count={1}
          height="h-20"
          loading={loadingCampaignInfo || loadingShiftList}
          error={shiftListError || campaignInfoError}
          isEmpty={isEmpty(campaignInfo) || isEmpty(shiftList)}
          retry={() => {
            dispatch(getShifts(campaignId));
            dispatch(getCampaignInfo(campaignId));
          }}
        />) : (<div>

        <div className="flex space-x-6">
          <LabeledSelect
            label="Appointment Date"
            getOptionLabel={(option) => option.value}
            placeholder="Shipping Date"
            onChange={(date) => {
              updateOrder({date, shift: undefined}, order);
            }}
            options={campaignInfo?.date
              .map(option => {
                return {value: option};
              })}
            value={order?.date}
          />
          <LabeledSelect
            label="Appointment Time"
            placeholder={order?.date?.length === 0 ? 'Please select a date first' : 'Select...'}
            onChange={(slot) => {
              updateOrder({shift: slot}, order);
            }}
            getOptionValue={(option) => option?.id}
            getOptionLabel={(option) => `${option?.name} [${utcToLocalTimeString(option?.start_time)}-${utcToLocalTimeString(option?.end_time)}]`}
            options={availableShift}
            value={order?.shift}
          />

          <Input
            type="number"
            color="blue"
            placeholder="Order Quantity"
            value={order?.quantity ?? ''}
            onChange={(e) => {
              updateOrder({quantity: e.target.value}, order);
            }}
          />
        </div>
        <Input
          type="text"
          color="blue"
          placeholder="Remark"
          value={order?.remarks ?? ''}
          onChange={(e) => {
            updateOrder({remarks: e.target.value}, order);
          }}
        />
      </div>)}
    </>

  );
};

export default UpdateOrderForm;
